<template>
  <div class="element-light">
    <div class="main-card">
      <div class="image-box"></div>
      <div class="info-box">
        <h2>Certified Internal Control Specialist</h2>
        <div class="info-row">
          <span class="label">Date:</span>
          <span class="value">17-21 February 2025</span>
        </div>
        <div class="info-row">
          <span class="label">Venue:</span>
          <span class="value">Holiday Inn Hotel, Harare</span>
        </div>
        <a
          class="register-btn"
          href="https://internalcontrolinstitute.co.zw/events-application-form"
          target="_blank"
          rel="noopener noreferrer"
        >REGISTER</a>
      </div>
    </div>
    <div class="desc-card">
      <h1>Certified Internal Control Specialist (CICS) Course</h1>
      <h3>Overview</h3>
      <p>
        Enhance your skills in internal controls and risk management with our internationally
        accredited Certified Internal Control Specialist (CICS) training.<br>
        This course is designed for professionals seeking to improve their understanding of effective internal control practices.
      </p>
    </div>
  </div>
</template>

<script setup>
// No logic is required for this static component
</script>

<style scoped>
.element-light {
  width: 100vw;
  background: #f1f1f1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

.main-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 10px #0001;
  display: flex;
  justify-content: space-between;
  gap: 40px;
  padding: 32px;
  max-width: 1100px;
  width: 100%;
  margin-bottom: 24px;
}

.image-box {
  width: 720px;
  height: 380px;
  /* background: url('/src/assets/babyduck.jpg') center/cover no-repeat; */
  border-radius: 8px;
}

.info-box {
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: flex-start;
}

.info-box h2 {
  color: #001b3b;
  font-size: 24px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin-bottom: 12px;
}

.info-row {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 17px;
  font-family: 'Jost', sans-serif;
}

.label {
  font-weight: 700;
}

.value {
  color: #454f5e;
}

.register-btn {
  margin-top: 16px;
  display: inline-block;
  background: #30308a;
  color: #fff;
  font-size: 15px;
  font-family: 'Jost', sans-serif;
  border-radius: 5px;
  padding: 14px 30px;
  letter-spacing: 1px;
  text-align: center;
  transition: background 0.2s;
}

.register-btn:hover {
  background: #001b3b;
}

.desc-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 10px #0001;
  padding: 32px;
  max-width: 1100px;
  width: 100%;
}

.desc-card h1 {
  color: #0f172a;
  font-size: 40px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin-bottom: 8px;
}

.desc-card h3 {
  color: #0f172a;
  font-size: 28px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  margin-bottom: 6px;
}

.desc-card p {
  font-size: 17px;
  font-family: 'Jost', sans-serif;
  color: #454f5e;
  line-height: 1.7;
  margin: 0;
}
</style>
